import { Link } from "react-router-dom";
import { categories } from "@/mocks/manhwa";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link
              to="/"
              className="text-2xl font-black tracking-tight font-serif text-white hover:text-primary-400 transition-colors"
            >
              <span className="text-primary-400">韩漫</span>大全
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 max-w-xs">
              韩漫漫画网汇聚众多韩漫大全作品，推荐好看的韩国漫画免费在线观看，加载速度快画质清晰，是您探索韩漫世界的理想平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">分类浏览</Link>
            </h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <Link to="/about" className="hover:text-primary-400 transition-colors">关于我们</Link>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <a
                  href="/about#contact"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                >
                  联系我们
                </a>
              </li>
              <li>
                <a
                  href="/about#faq"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-200"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫大全. 本站所有漫画均来自互联网，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="/about"
              className="text-xs text-foreground-500 hover:text-white transition-colors"
            >
              隐私政策
            </a>
            <a
              href="/about"
              className="text-xs text-foreground-500 hover:text-white transition-colors"
            >
              服务条款
            </a>
            <a
              href="/about#contact"
              className="text-xs text-foreground-500 hover:text-white transition-colors"
            >
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}